import { render, staticRenderFns } from "./p-header-style3.vue?vue&type=template&id=c0aab80a&scoped=true"
import script from "./p-header-style3.vue?vue&type=script&lang=js"
export * from "./p-header-style3.vue?vue&type=script&lang=js"
import style0 from "./p-header-style3.vue?vue&type=style&index=0&id=c0aab80a&prod&lang=css"
import style1 from "./p-header-style3.vue?vue&type=style&index=1&id=c0aab80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aab80a",
  null
  
)

export default component.exports